module.exports = __webpack_public_path__ + "img/ava-team.e3b06185.jpg";